import Base from './base'
import { AccountNotesResponse, Note } from '../types/account'

type AllForAccountIdParams = {
  aggregated: boolean
  simple: boolean
  page: number
  per_page: number
}

export default class Notes extends Base {
  allForUserId(userId: number): Promise<Note[]> {
    return this.api.get(`people/${userId}/notes.json`)
  }

  createForUserId(userId: number, note: string): Promise<unknown> {
    return this.api.post(`people/${userId}/notes.json`, { content: note })
  }

  allForAccountId(accountId: number, params: AllForAccountIdParams): Promise<AccountNotesResponse> {
    return this.api.get(`companies/${accountId}/notes`, { params })
  }

  createForAccountId(accountId: number, note: string): Promise<unknown> {
    return this.api.post(`companies/${accountId}/notes.json`, { content: note })
  }
}
